import React, { useMemo, useState } from "react";
import { useController } from "react-hook-form";
import styles from "./FileUploadButton.module.scss";
import { ReactComponent as UploadIcon } from "assets/svg/upload.svg";
import { combineClasses } from "utils/utils";
import { Progress } from "antd";
import { FileIcon } from 'react-file-icon';

const FileUploadButton = ({ name, control, onFileChange, className }) => {
  const [isLoading, setIsLoading] = useState({ loading: false, percent: 0, isError: false })

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: null,
  });

  const formattedSize = useMemo(() => {
    const formatFileSize = (bytes) => {
      if (bytes < 1024) return `${bytes} B`;
      else if (bytes < 1048576) return `${(bytes / 1024).toFixed(2)} KB`;
      else return `${(bytes / 1048576).toFixed(2)} MB`;
    };

    return value?.size ? formatFileSize(value.size) : 'Unknown size';
  }, [value?.size]); // Only re-run the memoization if file size changes


  const handleFilesChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    onChange(file);
    onFileChange(file, setIsLoading);
  };

  return (
    <div className={combineClasses(styles?.fileUploadContainer, className)}>
      {isLoading?.loading && !isLoading.isError
        ?
        <div className={styles.loaderContainer}>
          <div className={styles.leftSide}>
            <div className={styles.iconWrapper}>
              <FileIcon
                type={value?.type?.split("/")?.[0] || 'drive'}
                labelUppercase
                extension={value?.type?.split("/")?.pop() || 'unknown'}
                color="#3e9ef7"
              />
            </div>
            <div className={styles.fileInfo}>
              <div>{value?.name}</div>
              <span>{formattedSize}</span>
            </div>
          </div>

          <Progress size={50} type="circle" percent={isLoading?.percent} status={isLoading?.isError && "exception"} />
        </div>
        :
        <>
          <input
            type="file"
            id={name}
            onChange={handleFilesChange}
            className={styles?.fileInput}
          />
          <label htmlFor={name} className={styles?.fileLabel}>
            <UploadIcon width={16} height={16} />
            <span>Attach Media</span>
          </label>
          {error && <p className={styles?.errorMessage}>{error.message}</p>}
        </>
      }

    </div>
  );
};

export default FileUploadButton;
